import { Box, Col, Collapse, Flex, Radio, Row, theme } from '@/components';
import { type FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import type { UpdatedProjectSummaryModel } from '../_models/project';
import { ProjectStatusSummary } from '../detail/project-information/_components/ProjectStatusSummary';
import { BudgetVsRequested } from './BudgetVsRequestedSummary';

type ActiveLevel = 'level-1' | 'level-2';

type SummaryProp = z.infer<typeof UpdatedProjectSummaryModel>;

type Props = {
  aggregationSummary: SummaryProp;
};

export const ProjectSummary: FC<Props> = ({ aggregationSummary }) => {
  const { t } = useTranslation();
  const [projectRadioGroup, setProjectRadioGroup] =
    useState<ActiveLevel>('level-1');
  const { token } = theme.useToken();

  const aggregationDisplayTab = useMemo<
    { label: string; value: ActiveLevel }[]
  >(
    () => [
      { label: t('executed-finalized-requested-detail'), value: 'level-1' },
      { label: t('project-count'), value: 'level-2' },
    ],
    [t],
  );

  return (
    <Collapse
      accordion
      style={{ borderRadius: 0 }}
      items={[
        {
          label: t('budget-summary'),
          key: '1',
          style: { borderRadius: 0 },
          children: (
            <>
              <Flex justify="flex-end">
                <Box marginBottom={8}>
                  <Radio.Group
                    defaultValue={projectRadioGroup}
                    key={projectRadioGroup}
                    onChange={(e) => {
                      setProjectRadioGroup(e.target.value);
                    }}
                    buttonStyle="solid"
                  >
                    {aggregationDisplayTab.map((item) => (
                      <Radio.Button
                        type="primary"
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </Box>
              </Flex>
              <Row style={{ background: token.colorBgBase }}>
                <Col span={24}>
                  {projectRadioGroup === 'level-1' ? (
                    <BudgetVsRequested summary={aggregationSummary} />
                  ) : (
                    <ProjectStatusSummary summary={aggregationSummary} />
                  )}
                </Col>
              </Row>
            </>
          ),
        },
      ]}
    />
  );
};
